





























import { Vue, Component, Prop } from 'vue-property-decorator';
import { DataListItem } from '@/types';
import { Getter } from 'vuex-class';

@Component({name: 'app-data-list-item'})
export default class extends Vue {
  private tag = this.$options.name as string;
  private isHovered: boolean = false;

  @Prop({type: Object, required: true})
  private item!: DataListItem;

  @Prop({type: Number, required: true})
  private index!: number;

  @Getter('dataManagement/themeColor')
  private themeColor!: CSSStyleDeclaration['color'];

  @Getter('dataManagement/cardBgColor')
  private cardBgColor!: CSSStyleDeclaration['color'];

  public mounted(): void {
    this.$el.addEventListener('keydown', (e: Event) => {
      if ((e as KeyboardEvent).key === 'Enter') {
        this.openItem();
      }
    });
  }

  private openItem(): void {
    this.$emit('item-click', {
      childList: this.item.children || [],
      index: this.index,
      registerId: this.item.id,
    });
  }

}
